(function () {
  document.documentElement.classList.add('rvm-home-active');

  function normalize(value) {
    return (value || '')
      .toString()
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .toLowerCase()
      .trim();
  }

  function setup(root) {
    if (!root || root.dataset.rvmReady === 'true') return;
    root.dataset.rvmReady = 'true';

    var listing = root.querySelector('[data-rvm-listing]');
    var cards = Array.prototype.slice.call(root.querySelectorAll('[data-rvm-event]'));
    var searchInputs = Array.prototype.slice.call(root.querySelectorAll('[data-rvm-search]'));
    var filterButtons = Array.prototype.slice.call(root.querySelectorAll('[data-rvm-filter]'));
    var count = root.querySelector('[data-rvm-count]');
    var grid = root.querySelector('[data-rvm-grid]');
    var empty = root.querySelector('[data-rvm-empty]');
    var reset = root.querySelector('[data-rvm-reset]');
    var searchForm = root.querySelector('[data-rvm-search-form]');
    var activeFilter = 'all';
    var query = '';

    function updateButtons() {
      filterButtons.forEach(function (button) {
        var isActive = normalize(button.dataset.rvmFilter) === activeFilter;
        button.classList.toggle('is-active', isActive);
        if (button.hasAttribute('aria-pressed')) {
          button.setAttribute('aria-pressed', isActive ? 'true' : 'false');
        }
      });
    }

    function applyFilters() {
      var visibleCards = [];

      cards.forEach(function (card) {
        var category = normalize(card.dataset.rvmCategory);
        var haystack = normalize(card.dataset.rvmSearch);
        var categoryMatches = activeFilter === 'all' || category === activeFilter;
        var queryMatches = !query || haystack.indexOf(query) !== -1;
        var show = categoryMatches && queryMatches;

        card.hidden = !show;
        card.classList.remove('is-grid-odd', 'is-grid-even', 'is-only-visible');
        if (show) visibleCards.push(card);
      });

      visibleCards.forEach(function (card, index) {
        card.classList.add(index % 2 === 0 ? 'is-grid-odd' : 'is-grid-even');
        card.classList.toggle('is-only-visible', visibleCards.length === 1);
      });

      var visible = visibleCards.length;
      if (count) count.textContent = visible;
      if (grid) grid.hidden = visible === 0;
      if (empty) empty.hidden = visible !== 0;
      updateButtons();
    }

    function setQuery(value, source) {
      query = normalize(value);
      if (query) activeFilter = 'all';
      searchInputs.forEach(function (input) {
        if (input !== source) input.value = value;
      });
      applyFilters();
    }

    searchInputs.forEach(function (input) {
      input.addEventListener('input', function () {
        setQuery(input.value, input);
      });
    });

    filterButtons.forEach(function (button) {
      button.addEventListener('click', function () {
        activeFilter = normalize(button.dataset.rvmFilter) || 'all';
        query = '';
        searchInputs.forEach(function (input) {
          input.value = '';
        });
        applyFilters();

        if (listing && button.closest('.rvm-quick-links')) {
          listing.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
      });
    });

    if (searchForm) {
      searchForm.addEventListener('submit', function (event) {
        event.preventDefault();
        setQuery(searchInputs[0] ? searchInputs[0].value : '', searchInputs[0]);
        if (listing) listing.scrollIntoView({ behavior: 'smooth', block: 'start' });
      });
    }

    if (reset) {
      reset.addEventListener('click', function () {
        activeFilter = 'all';
        query = '';
        searchInputs.forEach(function (input) {
          input.value = '';
        });
        applyFilters();
      });
    }

    applyFilters();
  }

  function setupAll(scope) {
    var context = scope || document;
    if (context.matches && context.matches('[data-rvm-home]')) setup(context);
    Array.prototype.forEach.call(context.querySelectorAll('[data-rvm-home]'), setup);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      setupAll(document);
    });
  } else {
    setupAll(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    setupAll(event.target);
  });

  document.addEventListener('shopify:section:unload', function () {
    if (!document.querySelector('[data-rvm-home]')) {
      document.documentElement.classList.remove('rvm-home-active');
    }
  });
})();
